export const games = {
    yx: 'Игры',
    yxms: 'В крипто-играх все результаты определяются хэшами, сгенерированными до начала. Результат не может быть изменён чьей-либо волей, что гарантирует абсолютную честность и беспристрастность!',
    mnsm: 'Демо-режим',
    ljqw: 'Играть сейчас',
    loading: 'Загрузка, пожалуйста, подождите',
    dyh: 'Широкий выбор опционов, сотни процентов прибыли, высокая краткосрочная доходность инвестиций',
    qyhy: 'Опционные контракты',
    qsyhys: 'Опционы',
    kd: 'Открыть ордер',
    qt: 'Quick speculate',
    ljjy: 'Торговать сейчас',
}


// WEBPACK FOOTER //
// ./src/i18n/lang/games/ru.js